import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "wouter";
import { Cookie, X } from "lucide-react";

const COOKIE_CONSENT_KEY = "closerai_cookie_consent";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      // Small delay so it doesn't flash on page load
      const timer = setTimeout(() => setVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, "accepted");
    setVisible(false);
    // Initialize Google Analytics after consent
    if (typeof window !== "undefined" && !(window as any).__gaLoaded) {
      (window as any).__gaLoaded = true;
      const s = document.createElement("script");
      s.async = true;
      s.src = "https://www.googletagmanager.com/gtag/js?id=G-CFGW71NJNM";
      document.head.appendChild(s);
      (window as any).dataLayer = (window as any).dataLayer || [];
      const gtag = (...args: any[]) => { (window as any).dataLayer.push(args); };
      gtag("js", new Date());
      gtag("config", "G-CFGW71NJNM");
    }
  };

  const decline = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, "declined");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[100] p-4 animate-in slide-in-from-bottom-4 duration-500">
      <div className="container max-w-4xl">
        <div className="relative rounded-xl border border-white/10 bg-[#0F1420]/95 backdrop-blur-xl p-6 shadow-2xl shadow-black/50">
          <button
            onClick={decline}
            className="absolute top-3 right-3 text-muted-foreground hover:text-foreground transition-colors"
            aria-label="Close"
          >
            <X className="h-4 w-4" />
          </button>

          <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
            <div className="flex items-center gap-3 shrink-0">
              <div className="p-2 rounded-lg bg-primary/10 border border-primary/20">
                <Cookie className="h-5 w-5 text-primary" />
              </div>
            </div>

            <div className="flex-1">
              <p className="text-sm text-muted-foreground leading-relaxed">
                We use essential cookies to keep you logged in and analytics cookies to understand how you use CloserAI.
                No personal data is shared with advertisers.{" "}
                <Link href="/privacy" className="text-primary hover:underline">
                  Learn more
                </Link>
              </p>
            </div>

            <div className="flex items-center gap-3 shrink-0">
              <Button
                variant="ghost"
                size="sm"
                onClick={decline}
                className="text-muted-foreground hover:text-foreground"
              >
                Decline
              </Button>
              <Button
                size="sm"
                onClick={accept}
                className="bg-primary text-primary-foreground hover:bg-[#33DDFF]"
              >
                Accept
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
